module.exports = "https://stanwinstonschool.com/school-new-desktop.70bdc5cd48a8e823a579c269e880b646.jpg";